import { render, staticRenderFns } from "./GoodsBlacklist.vue?vue&type=template&id=6bed8332&scoped=true&"
import script from "./GoodsBlacklist.vue?vue&type=script&lang=js&"
export * from "./GoodsBlacklist.vue?vue&type=script&lang=js&"
import style0 from "./GoodsBlacklist.vue?vue&type=style&index=0&id=6bed8332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bed8332",
  null
  
)

export default component.exports